import { I18n } from 'aws-amplify';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { cloneDeep } from 'lodash';
import { addCustomerUserToCurrentProject, handleRestoreUser } from '@/service/userService';
import { createFilterOptions } from '@material-ui/lab';
import { updateProjectDetail } from '@/service/projectService';
import { getTicketListBetweenProjectAndB2C, archiveTicketList, getTicketDataGSI3WithFilter, getTicketById } from '@/service/ticketService';

export const newProjectUserDefaultData = {
    id: Date.now().toString(),
    avatar: '',
    mail: '',
    lastName: '',
    firstName: '',
    isAddNew: true,
};


/**
 * addNewRowProjectUser
 * @param {*} userAddList 
 * @param {*} setUserAddList 
 */
export const addNewRowProjectUser = (userAddList, setUserAddList) => {
    let userProjectAddListClone = cloneDeep(userAddList);

    let newUserProject = { ...newProjectUserDefaultData };
    newUserProject.id = Date.now().toString();

    userProjectAddListClone.push(newUserProject);
    setUserAddList(userProjectAddListClone);
};



/**
 * isFillUserData
 * @param {*} list 
 * @param {*} id 
 * @returns 
 */
export const isFillUserData = (list, id) => {
    try {
        let listClone = cloneDeep(list);
        const indexOfItem = Utils.findIndexInArrayById(id, list);

        let status = false;

        for (let key in listClone[indexOfItem]) {
            if (['mail', 'firstName', 'lastName'].includes(key)) {
                if (typeof listClone[indexOfItem][key] !== 'string') {
                    throw new Error('List fields contain some elements which are not string type');
                }
                status = status | !Utils.isEmptyString(listClone[indexOfItem][key]);
            }
        }
        return status;
    } catch (err) {
        console.error({ PopupDeleteItem: err });
        return true;
    }
};


/**
 * reMoveRowProjectUser
 * @param {*} id 
 * @param {*} userAddList 
 * @param {*} setUserAddList
 */
export const reMoveRowProjectUser = (argsAll, id, userAddList, setUserAddList) => {
    let errorsList = argsAll.errors;
    let currentAddList = cloneDeep(userAddList);

    currentAddList = currentAddList.filter((e, i) => e.id !== id);
    let mailDuplicate = findMailDuplicate(currentAddList);
    currentAddList.forEach(item => {
        if (!mailDuplicate.includes(item.mail.trim().toLowerCase()) && errorsList[`${item.id}`]?.mail === I18n.get('USER09MSG007')) {
            delete errorsList[`${item.id}`]?.mail;
            argsAll.setErrors(errorsList);
        }
    });
    setUserAddList(currentAddList);
};


/**
 * onClickCancelEdit
 * @param {*} argsAll 
 */
export const onClickCancelEdit = (argsAll) => {
    if (isEmptyUserAddList(argsAll)) {
        argsAll.setUserAddList([]);
        return;
    };
    argsAll.setIsOpenModalConfirmCancel(true);
}


/**
 * onSubmitCancelEdit
 * @param {*} argsAll 
 */
export const onSubmitCancelEdit = (argsAll) => {
    let userAddList = cloneDeep(argsAll.userAddList);
    userAddList = userAddList.map((item, index) => {
        return {
            ...item,
            usage: Constant.SYSTEM_USAGE_TYPE.USER,
            affiliationOrganization: argsAll.corporationId,
            mail: '',
            status: Constant.STATUS_OF_USER.WAITING,
            firstName: '',
            lastName: '',
            isAutocomplete: false
        }
    })
    argsAll.setUserAddList(userAddList);
    argsAll.setErrors({});
}

export const isEmptyUserAddList = argsAll => {
    let count = 0;
    let userAddLists = cloneDeep(argsAll.userAddList);
    for (let i = 0; i < userAddLists.length; i++) {
        let user = userAddLists[i];
        if (
            Utils.isEmptyString(user.mail) &&
            Utils.isEmptyString(user.firstName) &&
            Utils.isEmptyString(user.lastName)
        ) {
            count += 1;
        }
    }
    return count === userAddLists.length;
};


/**
 * updateSuggestCustomerUserList
 * @param {*} customerUserList 
 * @param {*} argsAll 
 */
export const updateSuggestCustomerUserList = (customerUserList, argsAll) => {
    let suggestList = [];

    if (!Utils.isEmptyArray(customerUserList)) {
        // Sort customerUserList by created desc
        customerUserList = Utils.sortByCreatedAtDesc(customerUserList);

        customerUserList.forEach(userInfo => {
            suggestList.push({
                id: userInfo.id,
                mail: userInfo.mail,
                label: userInfo.mail
            })
        })
    }

    argsAll.setSuggestCustomerUserList(suggestList);
    argsAll.setDefaultSuggestCustomerUserList(suggestList);
}


/**
 * onSelectSugguestUser
 * @param {*} value 
 * @param {*} argsAll 
 * @param {*} user 
 * @returns 
 */
export const onSelectSugguestUser = (value, argsAll, user) => {
    let selectedUserId = value.id;
    if (!selectedUserId) return;

    let selectedUserInfo = argsAll.customerListCanAdd.find(userDetail => userDetail.id === selectedUserId);
    if (Utils.isEmptyObject(selectedUserInfo)) return;

    let currentAddList = cloneDeep(argsAll.userAddList);
    let selectedIndexInList = Utils.findIndexInArrayById(user.id, currentAddList);
    if (selectedIndexInList === -1) return;

    currentAddList[selectedIndexInList].avatar = '';
    currentAddList[selectedIndexInList].mail = selectedUserInfo.mail;
    currentAddList[selectedIndexInList].lastName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, selectedUserInfo.lastName);
    currentAddList[selectedIndexInList].firstName = Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, selectedUserInfo.firstName);
    currentAddList[selectedIndexInList].isAutocomplete = true;

    argsAll.setUserAddList(currentAddList);

    // Remove error 
    let currentError = cloneDeep(argsAll.errors);
    if (currentError.hasOwnProperty(user.id)) {
        delete currentError[user.id];
        argsAll.setErrors(currentError);
    }
}


export const filterSugguestionOption = createFilterOptions({
    matchFrom: 'any',
    stringify: (option) => option.label,
});

export const validateEmail = (email, userAddList, userId) => {
    let userAddListClone = cloneDeep(userAddList);
    let errors;
    // validate email
    if (Utils.isEmptyString(email?.trim())) {
        errors = I18n.get('COMMSG014');
    } else if (!Utils.validateEmail(email)) {
        errors = I18n.get('COMM01MSG07');
    } else if (email?.trim().length > Constant.EMAIL_MAX_LENGTH) {
        errors = I18n.get('COMMSG027').replace('{{maxLength}}', Constant.EMAIL_MAX_LENGTH);
    } else {
        let emails = userAddListClone.filter(x => x.id !== userId && x.mail.trim().toLowerCase() === email?.trim().toLowerCase());
        let isExistEmail = emails && emails.length > 0  ? true : false;
        if (isExistEmail) {
            errors = I18n.get('USER09MSG007');
        } else {
            errors = '';
        }
    }

    return errors;
};

export const validateNameUser = name => {
    let errors;
    if (Utils.isEmptyString(name?.trim())) {
        errors = I18n.get('COMMSG014');
    } else if (name?.trim().length > 200) {
        errors = I18n.get('COMMSG027').replace('{{maxLength}}', '200');
    } else {
        errors = '';
    }

    return errors;
};

export const findMailDuplicate = (userAddList) => {
    let valueArr = userAddList.map(item => item.mail.trim().toLowerCase()).filter(item => !!item);
    const mailDuplicate = valueArr.filter((item, idx) => valueArr.indexOf(item) !== idx);
    return mailDuplicate;
}

export const onChangeEmail = (e, userId, argsAll) => {
    let email = e.target.value;

    let userAddList = cloneDeep(argsAll.userAddList);
    const indexAdd = Utils.findIndexInArrayById(userId, userAddList);

    let errorsList = argsAll.errors;
    let errorsRow = errorsList[`${userId}`] ? errorsList[`${userId}`] : {};

    let errors = validateEmail(email.trim(), userAddList, userId);
    if (!Utils.isEmptyString(errors)) {
        errorsRow.mail = errors;
        errorsList[`${userId}`] = errorsRow;
        argsAll.setErrors(errorsList);

        userAddList[indexAdd].mail = email;
        userAddList[indexAdd].isAutocomplete = false;
        argsAll.setUserAddList(userAddList);
    } else {
        delete errorsRow.mail;
        errorsList[`${userId}`] = errorsRow;
        argsAll.setErrors(errorsList);

        userAddList[indexAdd].mail = email;
        userAddList[indexAdd].isAutocomplete = false;
        argsAll.setUserAddList(userAddList);
    }

    let mailDuplicate = findMailDuplicate(userAddList);
    userAddList.forEach(item => {
        if (!mailDuplicate.includes(item.mail.trim().toLowerCase()) && errorsList[`${item.id}`]?.mail === I18n.get('USER09MSG007')) {
            delete errorsList[`${item.id}`]?.mail;
            argsAll.setErrors(errorsList);
        }
    });
};

export const onChangeNameUser = (e, userId, fieldName, argsAll) => {
    let nameValue = e.target.value;

    let userAddList = cloneDeep(argsAll.userAddList);
    const indexAdd = Utils.findIndexInArrayById(userId, userAddList);

    let errorsList = argsAll.errors;
    let errorsRow = errorsList[`${userId}`] ? errorsList[`${userId}`] : {};

    let errors = validateNameUser(nameValue);
    if (!Utils.isEmptyString(errors)) {
        errorsRow[`${fieldName}`] = errors;
        errorsList[`${userId}`] = errorsRow;
        argsAll.setErrors(errorsList);

        userAddList[indexAdd][`${fieldName}`] = nameValue;
        argsAll.setUserAddList(userAddList);
    } else {
        delete errorsRow[fieldName];
        errorsList[`${userId}`] = errorsRow;
        argsAll.setErrors(errorsList);

        userAddList[indexAdd][`${fieldName}`] = nameValue;
        argsAll.setUserAddList(userAddList);
    }
};

export const checkDisableBtnSubmit = (argAll) => {
    if(Utils.isEmptyArray(argAll.userAddList)) {
        argAll.setIsDisableBtnSubmit(true);
        return;
    }
    
    if(Utils.isEmptyObject(validateUserAddList(argAll.userAddList))) {
        argAll.setIsDisableBtnSubmit(false);
    } else {
        argAll.setIsDisableBtnSubmit(true);
    }
}

export const validateUserAddList = (userAddList) => {
    if (Utils.isEmptyArray(userAddList)) return;

    let errors = {};
    userAddList.forEach(user => {
        errors[user.id] = {};

        let errorLastName = validateNameUser(user.lastName);
        if (!Utils.isEmptyString(errorLastName)) {
            errors[user.id].lastName = errorLastName;
        } else {
            delete errors[user.id].lastName;
        }

        let errorFirstName = validateNameUser(user.firstName);
        if (!Utils.isEmptyString(errorFirstName)) {
            errors[user.id].firstName = errorFirstName;
        } else {
            delete errors[user.id].firstName;
        }

        let errorEmail = validateEmail(user.mail?.trim(), userAddList, user.id);
        if (!Utils.isEmptyString(errorEmail)) {
            errors[user.id].mail = errorEmail;
        } else {
            delete errors[user.id].mail;
        }
    });

    let errorList = {};
    for(let key in errors) {
        if(!Utils.isEmptyObject(errors[key])) {
            errorList[key] = errors[key];
        }
    }
    
    return errorList;
}

export const handleSubmit = async argsAll => {
    // validate data
    let userAddList = cloneDeep(argsAll.userAddList);
    let errors = validateUserAddList(userAddList);

    argsAll.setErrors(errors);
    
    if (!Utils.isEmptyObject(errors)) {
        return;
    }

    // Add user to project
    argsAll.setIsLoading(true);
    let customerUserListAdd = [];
    argsAll.userAddList.forEach(userAdd => {
        if (userAdd.mail && userAdd.firstName && userAdd.lastName) {
            customerUserListAdd.push({
                clientId: userAdd.id,
                mail: userAdd.mail.trim(),
                firstName: userAdd.firstName.trim(),
                lastName: userAdd.lastName.trim(),
            });
        }
    });

    let addCustomerResult = await addCustomerUserToCurrentProject(argsAll.API, argsAll.corporationId, argsAll.projectDetail.id, argsAll.userDetail.id, customerUserListAdd);
    if (!addCustomerResult || !addCustomerResult.status) {
        argsAll.setIsLoading(false);
        return;
    }

    if (!Utils.isEmptyArray(addCustomerResult.errorList)) {
        addCustomerResult.errorList.forEach(userError=>{
            errors[`${userError.clientId}`] = {
                mail: I18n.get(userError.error)
            }
        });
    }

    argsAll.setErrors(errors);

    if (Utils.isEmptyArray(addCustomerResult.successList)) {
        argsAll.setIsLoading(false);
        return;
    }

    addCustomerResult.successList.forEach(userSuccess=>{
        userAddList = userAddList.filter(userAdd => userAdd.id !== userSuccess.clientId)
    });
    argsAll.setIsAddNewUser(true);
    argsAll.setUserAddList(userAddList);
    argsAll.setTriggerReload(Date.now().toString());
};


/**
 * isDisableBtnDeleteProjectB2C
 * @param {*} argsAll 
 * @param {*} user 
 * @returns 
 */
export const isDisableBtnDeleteProjectB2C = (argsAll, user) => {
    if (!argsAll.userDetail || Utils.isEmptyObject(argsAll.userDetail)) {
        return true;
    }

    if (!user || Utils.isEmptyObject(user) || user.active === Constant.ACTIVE_FLAG.DELETED || user.activeInProject === Constant.ACTIVE_FLAG.DELETED) {
        return true;
    }

    return false;
}


/**
 * onClickDeleteProjectB2C
 * @param {*} argsAll 
 * @param {*} user 
 * @returns 
 */
export const onClickDeleteProjectB2C = async (argsAll, user) => {
    if (!user || Utils.isEmptyObject(user) || user.active === Constant.ACTIVE_FLAG.DELETED || user.activeInProject === Constant.ACTIVE_FLAG.DELETED) {
        return;
    }

    argsAll.setIsOpenDialogConfirmDelete({
        isEnable: true,
        userId: user.id
    });
}


/**
 * handleDeleteProjectB2CUser
 * @param {*} argsAll 
 * @param {*} userId 
 * @returns 
 */
export const handleDeleteProjectB2CUser = async (argsAll, userId, userProjectId) => {
    if (!userId || !userProjectId) return;
    argsAll.setIsLoading(true);

    let objDeleteProjectB2C = {
        id: userProjectId,
        active: Constant.ACTIVE_FLAG.DELETED,
        type: Constant.PROJECT_TYPE.USER_CUSTOMER,
    }
    let deleteB2CResult = await updateProjectDetail(argsAll.API, userProjectId, objDeleteProjectB2C);
    if (!deleteB2CResult || !deleteB2CResult.id) {
        argsAll.setIsLoading(false);
        return;
    }

    // Archive ticket
    let getTicketListOfB2C = await getTicketListBetweenProjectAndB2C(
        argsAll.API,
        argsAll.corporationId,
        argsAll.projectId,
        userId
    );
    if (!Utils.isEmptyArray(getTicketListOfB2C)) {
        let allTicketOfUser = getTicketListOfB2C.filter(
            ticket =>
                ticket.public === Constant.TICKET_PUBLIC.PUBLIC &&
                ticket.liveOrArchived === Constant.LIVE_OR_ARCHIVED.LIVE &&
                [
                    Constant.TICKET_TYPE.QA,
                    Constant.TICKET_TYPE.INTERNAL_QA,
                    Constant.TICKET_TYPE.EXTERNAL_QA,
                    Constant.TICKET_TYPE.DELEGATE,
                    Constant.TICKET_TYPE.BROADCAST_PARENT,
                    Constant.TICKET_TYPE.BROADCAST_CHILD
                ].includes(ticket.ticketType)
        );
        let ticketListToArchive = await prepareTicketListWithoutNoticeGroup(argsAll.API, allTicketOfUser);
        if (!Utils.isEmptyArray(ticketListToArchive)) {
            await archiveTicketList(argsAll.API, ticketListToArchive, argsAll.userDetail.id);
        }
    }

    let currentUserIndexInCustomerList = Utils.findIndexInArrayById(userId, argsAll.customerList);
    let currentCustomerList = cloneDeep(argsAll.customerList);
    currentCustomerList[currentUserIndexInCustomerList].activeInProject = Constant.ACTIVE_FLAG.DELETED;
    argsAll.setCustomerList(currentCustomerList);
    argsAll.setIsLoading(false);
}



/**
 * prepareTicketListWithoutNoticeGroup
 * @param {*} API 
 * @param {*} ticketList 
 * @returns 
 */
export const prepareTicketListWithoutNoticeGroup = async (API, ticketList) => {
    if (Utils.isEmptyArray(ticketList)) {
        return [];
    }

    try {
        let ticketListResult = [];

        await Promise.all(
            ticketList.map(async ticket => {
                if ([Constant.TICKET_TYPE.BROADCAST_CHILD, Constant.TICKET_TYPE.BROADCAST_PARENT].includes(ticket.ticketType)) {
                    let parentTicketId = ticket.id;
                    if (Constant.TICKET_TYPE.BROADCAST_CHILD === ticket.ticketType) {
                        parentTicketId = ticket.parent;
                    }

                    let parentTicketData = await getTicketById(API, parentTicketId);
                    if (parentTicketData.customer === 'NOTICE_CUSTOMER') {
                        let isNoticeGroup = await isNoticeGroupTicket(API, parentTicketId);
                        if (!isNoticeGroup) {
                            if (Constant.TICKET_TYPE.BROADCAST_CHILD === ticket.ticketType && Utils.findIndexInArrayById(ticket.id, ticketListResult) === -1) {
                                ticketListResult.push(ticket);
                            }
                            if (Utils.findIndexInArrayById(parentTicketData.id, ticketListResult) === -1) {
                                ticketListResult.push(parentTicketData);
                            }
                        }
                    } else if (
                        ![
                            Constant.NOTICE_GROUP_CUSTOMER.ALL_CUSTOMER_PROJECT,
                            Constant.NOTICE_GROUP_CUSTOMER.ALL_GUEST_CUSTOMER_USER,
                            Constant.NOTICE_GROUP_CUSTOMER.ALL_GENERAL_PROJECT,
                            Constant.NOTICE_GROUP_CUSTOMER.ALL_USER_IN_BASE_PROJECT
                        ].includes(parentTicketData.customer)
                    ) {
                        if (Constant.TICKET_TYPE.BROADCAST_CHILD === ticket.ticketType && Utils.findIndexInArrayById(ticket.id, ticketListResult) === -1) {
                            ticketListResult.push(ticket);
                        }
                        if (Utils.findIndexInArrayById(parentTicketData.id, ticketListResult) === -1) {
                            ticketListResult.push(parentTicketData);
                        }
                    }
                } else {
                    ticketListResult.push(ticket);
                }
            })
        );

        return ticketListResult;
    } catch (error) {
        console.log('prepareTicketListWithoutNoticeGroup error: ', error);
        return [];
    }
};


/**
 * isNoticeGroupTicket
 * @param {*} API 
 * @param {*} parentId 
 * @returns 
 */
export const isNoticeGroupTicket = async (API, parentId) => {
    let isNoticeGroup = false;

    let customerNoticeData = await getTicketDataGSI3WithFilter(
        API,
        parentId,
        Constant.TICKET_DATA_TYPE.FIELD,
        Constant.TICKET_DATA_ID.CUSTOMER_NOTICE
    );

    if (!Utils.isEmptyArray(customerNoticeData)) {
        let customerNoticeDataValue = JSON.parse(customerNoticeData[0].dataValue).value;
        let prefixOfId = Utils.getPrefixOfId(customerNoticeDataValue);
        if (prefixOfId !== 'user' && prefixOfId !== 'project') {
            switch (customerNoticeDataValue) {
                case Constant.NOTICE_ALL_CUSTOMER.ALL_CUSTOMER_PROJECT:
                case Constant.NOTICE_ALL_CUSTOMER.ALL_GUEST_CUSTOMER_USER:
                case Constant.NOTICE_ALL_CUSTOMER.ALL_GENERAL_PROJECT:
                case Constant.NOTICE_ALL_CUSTOMER.ALL_USER_IN_BASE_PROJECT:
                    isNoticeGroup = true;
                    break;
                default:
                    isNoticeGroup = false;
                    break;
            }
        } else {
            isNoticeGroup = false;
        }
    }

    return isNoticeGroup;
}


/**
 * isDisplayBtnRestoreB2C
 * @param {*} argsAll 
 * @param {*} user 
 * @returns 
 */
export const isDisplayBtnRestoreB2C = (argsAll, user) => {
    if (!user || Utils.isEmptyObject(user)) {
        return false;
    }

    if ([Constant.STATUS_OF_USER.DELETED, Constant.STATUS_OF_USER.REJECT].includes(Utils.getB2CStatusInProject(user, user.activeInProject))) {
        return true;
    }

    return false;
}


/**
 * handleClickRestoreB2CInProject
 * @param {*} argsAll 
 * @param {*} user 
 * @returns 
 */
export const handleClickRestoreB2CInProject = (argsAll, user) => {
    if (!user || Utils.isEmptyObject(user)) {
        return;
    }

    argsAll.setSelectedUser(user);
    argsAll.setIsOpenDialogConfirmRestoreUser(true);
}


/**
 * onSubmitRestoreB2CInProject
 * @param {*} argsAll 
 * @returns 
 */
export const onSubmitRestoreB2CInProject = async (argsAll) => {
    if (!argsAll || !argsAll.selectedUser || Utils.isEmptyObject(argsAll.selectedUser)) return;

    let restoreUserId = argsAll.selectedUser.id;
    let restoreB2CRequestDto = {
        userId: restoreUserId,
        type: Constant.RESTORE_USER_TYPE.B2C_IN_PROJECT,
        projectId: argsAll.projectDetail.id,
        currentUserId: argsAll.userDetail.id
    }

    argsAll.setIsLoading(true);
    let restoreResult = await handleRestoreUser(argsAll.API, restoreB2CRequestDto);
    if (!restoreResult) {
        argsAll.setIsLoading(false);
        return;
    }

    if (!restoreResult.status) {
        argsAll.setIsLoading(false);
        if (!restoreResult?.errorMessage) {
            return;
        }

        if (restoreResult?.errorMessage === Constant.DATA_CHANGED_PLEASE_RELOAD_ERROR) {
            argsAll.setIsOpenModalReloadPage(true);
        } else if (argsAll.setEditUserError){
            argsAll.setEditUserError(I18n.get(restoreResult?.errorMessage))
        }
        return;
    }
    
    // Reload
    argsAll.setTriggerReload(Date.now().toString());
    argsAll.setIsLoading(false);
    argsAll.enqueueSnackbar(I18n.get('MSG-CM-UPDATE-DATA-SUCCESS'), {
        variant: 'success',
        autoHideDuration: 3000
    });
}
